import { render, staticRenderFns } from "./ReturnToStoreMaterials.vue?vue&type=template&id=98141330"
import script from "./ReturnToStoreMaterials.vue?vue&type=script&lang=js"
export * from "./ReturnToStoreMaterials.vue?vue&type=script&lang=js"
import style0 from "./ReturnToStoreMaterials.vue?vue&type=style&index=0&id=98141330&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports